import { render, staticRenderFns } from "./using-storyboards.vue?vue&type=template&id=2497e06c&"
import script from "./using-storyboards.vue?vue&type=script&lang=js&"
export * from "./using-storyboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports